document.addEventListener('DOMContentLoaded', () => {
    const chatForm = document.getElementById('chat-form');
    const userInput = document.getElementById('user-input');
    const chatMessages = document.getElementById('chat-messages');
    const chatButton = document.getElementById('chat-button');
    const chatContainer = document.getElementById('chat-container');
    const closeButton = document.getElementById('close-chat');
 
    // Store conversation ID
    let conversationId = null;
 
    // Chat button click handler - open chat
    chatButton.addEventListener('click', () => {
        chatContainer.classList.add('open');
        chatButton.style.display = 'none';
        // Focus on input when chat opens
        setTimeout(() => {
            userInput.focus();
        }, 300);
    });
 
    // Close button click handler - close chat
    closeButton.addEventListener('click', () => {
        chatContainer.classList.remove('open');
        chatButton.style.display = 'flex';
    });
 
    // Function to add a message to the chat
    function addMessage(message, isUser = false) {
        const messageDiv = document.createElement('div');
        messageDiv.classList.add('message');
        messageDiv.classList.add(isUser ? 'user' : 'bot');
 
        const messageContent = document.createElement('div');
        messageContent.classList.add('message-content');
 
        if (isUser) {
            // For user messages, just use text content
            messageContent.textContent = message;
        } else {
            // For bot messages, format the text with paragraphs and lists
            const formattedMessage = formatBotMessage(message);
            messageContent.innerHTML = formattedMessage;
        }
 
        messageDiv.appendChild(messageContent);
        chatMessages.appendChild(messageDiv);
 
        // Scroll to bottom
        chatMessages.scrollTop = chatMessages.scrollHeight;
    }
 
    // Function to format bot messages for better readability
    function formatBotMessage(message) {
        // Process bold text with asterisks (like **text**)
        message = message.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
 
        // First, handle any numbered lists that span multiple lines
        const lines = message.split('\n');
        let inList = false;
        let listItems = [];
        let processedLines = [];
 
        lines.forEach(line => {
            // Check if this line starts a numbered list item (1., 2., etc. or 1), 2), etc.)
            // More flexible regex to catch various numbering formats
            const listItemMatch = line.match(/^(\s*)(\d+[\.\)\:])(\s+)(.+)/);
            // Also check for bold numbered items like **1.** Text
            const boldListItemMatch = line.match(/^(\s*)\*\*(\d+[\.\)\:])\*\*(\s+)(.+)/);
 
            if (listItemMatch || boldListItemMatch) {
                const itemContent = boldListItemMatch ?
                    boldListItemMatch[4].trim() :
                    listItemMatch[4].trim();
 
                if (!inList) {
                    // Start a new list
                    inList = true;
                    listItems = [];
                }
 
                // Add this item to the current list (without explicit value attribute)
                // Let the browser handle the numbering automatically
                listItems.push(`<li>${itemContent}</li>`);
            } else if (inList && line.trim() === '') {
                // Empty line ends the list
                processedLines.push(`<ol class="numbered-list">${listItems.join('')}</ol>`);
                listItems = [];
                inList = false;
            } else if (inList && (line.trim().startsWith('- ') || line.trim().startsWith('* '))) {
                // This is a sub-bullet in a list
                const bulletContent = line.trim().substring(2);
                listItems[listItems.length - 1] += `<ul><li>${bulletContent}</li></ul>`;
            } else if (inList) {
                // This line is part of the previous list item (continuation)
                if (listItems.length > 0) {
                    listItems[listItems.length - 1] = listItems[listItems.length - 1].replace('</li>', ` ${line.trim()}</li>`);
                } else {
                    // If somehow we're in a list but have no items, just add the line
                    processedLines.push(line);
                    inList = false;
                }
            } else {
                // Regular line
                processedLines.push(line);
            }
        });
 
        // If we're still in a list at the end, close it
        if (inList && listItems.length > 0) {
            processedLines.push(`<ol class="numbered-list">${listItems.join('')}</ol>`);
        }
 
        // Join the processed lines back together
        let formattedText = processedLines.join('\n');
 
        // Split by double newlines to create paragraphs
        const paragraphs = formattedText.split(/\n\n+/);
 
        // Process each paragraph
        formattedText = paragraphs.map(para => {
            // Skip if it's already HTML
            if (para.includes('<ol') || para.includes('<ul') || para.includes('<p')) {
                return para;
            }
 
            // Check if this is a section header (ends with a colon)
            if (para.trim().endsWith(':')) {
                return `<p class="section-header">${para}</p>`;
            }
 
            // Regular paragraph
            return `<p>${para}</p>`;
        }).join('');
 
        // Replace single newlines with line breaks (but not inside HTML tags)
        formattedText = formattedText.replace(/\n(?![<])/g, '<br>');
 
        // Highlight product names and categories with bold (if not already bold)
        formattedText = formattedText.replace(
            /(?<!<strong>)(Ultra Precision Scales|Large Ultra Precision Scales|Premium Ultra Precision Scales|Explosion Proof Scales|Industrial Scales|Cylinder Scales|Parts Counting Scales|Ultra Precision|SAW technology)(?!<\/strong>)/g,
            '<strong>$1</strong>'
        );
 
        return formattedText;
    }
 
    // Function to show typing indicator
    function showTypingIndicator() {
        const indicator = document.createElement('div');
        indicator.classList.add('message', 'bot', 'typing-indicator-container');
 
        const typingIndicator = document.createElement('div');
        typingIndicator.classList.add('typing-indicator');
 
        for (let i = 0; i < 3; i++) {
            const dot = document.createElement('span');
            typingIndicator.appendChild(dot);
        }
 
        indicator.appendChild(typingIndicator);
        chatMessages.appendChild(indicator);
        chatMessages.scrollTop = chatMessages.scrollHeight;
 
        return indicator;
    }
 
    // Function to remove typing indicator
    function removeTypingIndicator(indicator) {
        if (indicator && indicator.parentNode === chatMessages) {
            chatMessages.removeChild(indicator);
        }
    }
 
    // Function to send message to API
    async function sendMessage(message) {
        try {
            const typingIndicator = showTypingIndicator();
 
            const response = await fetch('/api/chat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message: message,
                    conversation_id: conversationId
                })
            });
 
            if (!response.ok) {
                throw new Error('Failed to get response from server');
            }
 
            const data = await response.json();
 
            // Remove typing indicator
            removeTypingIndicator(typingIndicator);
 
            // Update conversation ID
            conversationId = data.conversation_id;
 
            // Add bot response
            addMessage(data.response, false);
        } catch (error) {
            console.error('Error:', error);
 
            // Remove typing indicator if there was an error
            const typingIndicators = document.querySelectorAll('.typing-indicator-container');
            typingIndicators.forEach(indicator => {
                removeTypingIndicator(indicator);
            });
 
            // Add error message
            addMessage('Sorry, I encountered an error. Please try again later.', false);
        }
    }
 
    // Handle form submission
    chatForm.addEventListener('submit', (e) => {
        e.preventDefault();
 
        const message = userInput.value.trim();
        if (!message) return;
 
        // Add user message to chat
        addMessage(message, true);
 
        // Clear input
        userInput.value = '';
 
        // Send message to API
        sendMessage(message);
    });
 
    // Focus input on page load
    userInput.focus();
});